import { MaintenanceCounterWithPercentage } from '../models/maintenancelogs.model';

export const MAINTENANCE_STATUS_COLORS = {
  healthy: '#FFFFFF',
  warning: '#FFF176',
  critical: '#FFA876',
} as const;

export function getLeastRemainingUsage(
  counters: readonly MaintenanceCounterWithPercentage[] | null | undefined,
): number {
  const highestUsagePercentage = (counters ?? []).reduce(
    (highestUsage, counter) => {
      const percentage = counter.percentage;
      return typeof percentage === 'number' && Number.isFinite(percentage)
        ? Math.max(highestUsage, percentage)
        : highestUsage;
    },
    0,
  );

  return Math.max(0, Math.min(100, 100 - highestUsagePercentage));
}

export function getMaintenanceStatusColor(remainingUsage: number): string {
  const normalizedRemainingUsage = Number.isFinite(remainingUsage)
    ? Math.max(0, Math.min(100, remainingUsage))
    : 100;

  if (normalizedRemainingUsage > 25) {
    return MAINTENANCE_STATUS_COLORS.healthy;
  }

  if (normalizedRemainingUsage > 10) {
    return MAINTENANCE_STATUS_COLORS.warning;
  }

  return MAINTENANCE_STATUS_COLORS.critical;
}
